export const authScreens = [
  { name: "login" },
  { name: "registration" },
  { name: "forgot-password" },
  { name: "reset-password" },
  { name: "set-password" },
];
